export default function LoadingSearchField() {
  return <div className="animate-pulse h-8 bg-skeleton rounded-3xl min-w-[40px] max-w-xl"></div>
}
